import { Routes } from '@angular/router';

export const helpRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./help.page').then((m) => m.HelpPage),
  },
];
